import { useQuery } from "react-query";
import { _get } from "../utils/request";

// [username] pages are ISR (getStaticProps), and in production Next's router
// also caches each page's static data for the whole session. So every tab can
// hold a different, stale copy of the streamer (e.g. has_store flipped after
// the page was cached) and the tab list differs from page to page until a hard
// refresh. Re-fetch the streamer on the client and merge it over the static
// props so tabs + panels always reflect the live state.
//
// `isFresh` is false until the client fetch settles — use it to hold off on
// redirects that would otherwise act on stale static data.
const useFreshStreamerData = (staticData = {}, error) => {
  const { username } = staticData;
  const enabled = !!username && !error;

  const { data: freshData, isFetched } = useQuery(
    ["streamer-public", username],
    async () => {
      const { json } = await _get(`users/${username}`);
      return json.data;
    },
    {
      enabled,
      staleTime: 0,
      refetchOnWindowFocus: false,
      retry: false,
    }
  );

  // Static props also carry server-only payment flags; keep them and let the
  // fresh API fields win.
  const data = freshData ? { ...staticData, ...freshData } : staticData;
  return { data, isFresh: !enabled || isFetched };
};

export { useFreshStreamerData };
